import React from "react";

const ProjectList = ({ projects = [], onTogglePortfolio }) => {
  console.log("ProjectList rendered with projects:", projects);
  
  return (
    <div className="w-full overflow-x-auto rounded-2xl">
      <table className="min-w-full bg-white border-collapse">
        <thead>
          <tr className="bg-gray-50 text-left text-sm text-gray-600">
            <th className="py-3 px-4 rounded-tl-2xl whitespace-nowrap border-b">
              Project Name
            </th>
            <th className="py-3 px-4 whitespace-nowrap border-b text-center">
              Status
            </th>
            <th className="py-3 px-4 rounded-tr-2xl whitespace-nowrap border-b text-center">
              Show on Homepage
            </th>
          </tr>
        </thead>
        <tbody>
          {projects.length === 0 ? (
            <tr>
              <td
                colSpan="3"
                className="py-6 px-4 text-center text-gray-400 text-sm"
              >
                No projects added yet.
              </td>
            </tr>
          ) : (
            projects.map((p) => (
              <tr key={p.project_id} className="border-b hover:bg-gray-50 transition-colors">
                {/* Name */}
                <td className="py-3 px-4 text-sm font-medium text-gray-800">
                  {p.project_name}
                </td>

                {/* Status */}
                <td className="py-3 px-4 text-center">
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                    p.project_status === 'Ongoing' ? 'bg-blue-100 text-blue-700' : 
                    p.project_status === 'Completed' ? 'bg-green-100 text-green-700' : 
                    'bg-gray-100 text-gray-600'
                  }`}>
                    {p.project_status || p.status_label || "Not Set"}
                  </span>
                </td>

                {/* Toggle Switch */}
                <td className="py-3 px-4 text-center">
                  <button
                    type="button"
                    onClick={() => onTogglePortfolio(p)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                      p.show_on_portfolio === 1
                        ? "bg-green-500 focus:ring-green-500"
                        : "bg-gray-300 focus:ring-gray-300"
                    }`}
                    role="switch"
                    aria-checked={p.show_on_portfolio === 1}
                    title={
                      p.show_on_portfolio === 1
                        ? "Visible on website - Click to hide"
                        : "Hidden from website - Click to show"
                    }
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        p.show_on_portfolio === 1 ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectList;